import reqsTypes from "./reqs.types";

const INITIAL_STATE = {
  myReqs: [],
  myReqsPage: 1,
  myReqs_isLoading: false,

  allReqs: [],
  allReqsPage: 1,
  allReqs_isLoading: false,

  activeTab: 0,
};

const reqsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case reqsTypes.SET_REQS_TAB:
      return {
        ...state,
        activeTab: action.payload,
      };
    case reqsTypes.SET_MYREQS_PAGE:
      return {
        ...state,
        myReqsPage: action.payload,
      };
    case reqsTypes.SET_ALLREQS_PAGE:
      return {
        ...state,
        allReqsPage: action.payload,
      };

    //my loads
    case reqsTypes.FETCH_MYREQS_START:
      return {
        ...state,
        myReqs_isLoading: true,
      };
    case reqsTypes.FETCH_MYREQS_SUCCESS:
      if (state.myReqsPage > 1)
        return {
          ...state,
          myReqs_isLoading: false,
          myReqs: [...state.myReqs, ...action.payload],
        };
      else
        return {
          ...state,
          myReqs_isLoading: false,
          myReqs: [...action.payload],
        };

    //all loads
    case reqsTypes.FETCH_ALLREQS_START:
      return {
        ...state,
        allReqs_isLoading: true,
      };
    case reqsTypes.FETCH_ALLREQS_SUCCESS:
      if (state.allReqsPage > 1)
        return {
          ...state,
          allReqs_isLoading: false,
          allReqs: [...state.allReqs, ...action.payload],
        };
      else
        return {
          ...state,
          allReqs_isLoading: false,
          allReqs: [...action.payload],
        };

    //
    default:
      return state;
  }
};

export default reqsReducer;
